module.exports = __webpack_public_path__ + "static/img/chanpingduo.c1e5e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/chanpingduo.png
// module id = LyTZ
// module chunks = 0